import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ProgramStudentDetails.module.scss';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import ProgramStudentsTable from './ProgramStudentsTable';
import ViewAllStudentsModal from './ViewAllStudentsModal';
import AddStudentsModal from './AddStudentsModal';
import { useAuth } from '../../../contexts/AuthContext';

const ProgramStudentDetails = ({ students = [], programId, programTitle, onRefresh }) => {
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const { role, can } = useAuth();
    const canAddStudents = role !== 'Program Coordinator' || can('canAddStudents');

    const handleOpenAddModal = () => {
        setIsViewModalOpen(false);
        setIsAddModalOpen(true);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Student Details</h2>
                {canAddStudents && (
                    <Button
                        label={
                            <div className={styles.cta}>
                                <Icon name="plus" />
                                Add Students
                            </div>
                        }
                        variant="primary-light"
                        size="small"
                        onClick={handleOpenAddModal}
                    />
                )}
            </div>
            
            <div className={styles.tableWrapper}>
                <ProgramStudentsTable students={students} />
            </div>

            <div className={styles.footer}>
                <Button 
                    label={
                        <div className={styles.cta}>
                            <Icon name="arrow-up-right" />
                            View All Students
                        </div>
                    }
                    variant="primary-light"
                    size="small"
                    onClick={() => setIsViewModalOpen(true)}
                />
            </div>

            <ViewAllStudentsModal 
                isOpen={isViewModalOpen} 
                onClose={() => setIsViewModalOpen(false)} 
                programId={programId}
                programTitle={programTitle}
                onAddStudentsClick={handleOpenAddModal}
            />

            <AddStudentsModal 
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                programId={programId}
                onSuccess={onRefresh}
            />
        </div>
    );
};

ProgramStudentDetails.propTypes = {
  students: PropTypes.array,
  programId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  programTitle: PropTypes.string,
  onRefresh: PropTypes.func
};

export default ProgramStudentDetails;
